import { useReportViewDownloadUrlLazyQuery, type ReportsReportViewsCsv } from '__codegen__/api'
import { downloadFromLink } from 'legacy/common/utils/downloadFromLink'

export const useReportViewDownloads = () => {
  const [fetchReportViewDownloadUrl] = useReportViewDownloadUrlLazyQuery({
    // this call should always hit the api instead of being cached to get an updated s3 token
    fetchPolicy: 'network-only',
    onCompleted: res => {
      res.reportView.downloadUrl && downloadFromLink(res.reportView.downloadUrl)
    },
  })

  const downloadReportView = (reportView: ReportsReportViewsCsv) => {
    if (!reportView.downloadUrl) return

    fetchReportViewDownloadUrl({ variables: { reportViewId: reportView.id } })
  }

  return {
    downloadReportView,
  }
}

export type UseReportViewDownloadBehaviour = ReturnType<typeof useReportViewDownloads>
